import { createContext, useContext, useState, type ReactNode } from "react";

// Lets a screen publish its live record count to the sidebar nav pill
// (e.g. Customers "N" badge) without prop-drilling through the shell.
interface ShellContextValue {
  customerCount: number | undefined;
  setCustomerCount: (n: number | undefined) => void;
}

const ShellContext = createContext<ShellContextValue | null>(null);

export function ShellProvider({ children }: { children: ReactNode }) {
  const [customerCount, setCustomerCount] = useState<number | undefined>(undefined);
  return (
    <ShellContext.Provider value={{ customerCount, setCustomerCount }}>
      {children}
    </ShellContext.Provider>
  );
}

export function useShell(): ShellContextValue {
  const ctx = useContext(ShellContext);
  if (!ctx) throw new Error("useShell must be used within ShellProvider");
  return ctx;
}
